var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54171 14.5212C3.08992 14.5212 2.7688 14.3196 2.57838 13.9164C2.38784 13.5131 2.43382 13.1381 2.71633 12.7912L6.72921 7.91453V3.54199H5.8847C5.73418 3.54199 5.60798 3.49105 5.5061 3.38917C5.40434 3.28729 5.35345 3.16109 5.35345 3.01056C5.35345 2.85993 5.40434 2.73378 5.5061 2.63214C5.60798 2.53037 5.73418 2.47949 5.8847 2.47949H11.1154C11.2659 2.47949 11.3921 2.53043 11.494 2.63232C11.5958 2.7342 11.6466 2.8604 11.6466 3.01092C11.6466 3.16156 11.5958 3.2877 11.494 3.38935C11.3921 3.49111 11.2659 3.54199 11.1154 3.54199H10.2709V7.91453L14.2838 12.7912C14.5663 13.1381 14.6123 13.5131 14.4217 13.9164C14.2313 14.3196 13.9102 14.5212 13.4584 14.5212H3.54171ZM3.54171 13.4587H13.4584L9.20838 8.28783V3.54199H7.79171V8.28783L3.54171 13.4587Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/Lab.1fa72c19fe64f17adc55f2d767b7b94e.svg";
export { ForwardRef as ReactComponent };